import { render, staticRenderFns } from "./BroadcastForm.vue?vue&type=template&id=37b74b84&scoped=true&"
import script from "./BroadcastForm.vue?vue&type=script&lang=js&"
export * from "./BroadcastForm.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastForm.vue?vue&type=style&index=0&id=37b74b84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b74b84",
  null
  
)

export default component.exports